'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GATracking = require('./GATracking');

Object.defineProperty(exports, 'GATracking', {
  enumerable: true,
  get: function get() {
    return _GATracking.GATracking;
  }
});


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/GATracking/index.js